import { render, staticRenderFns } from "./integral-search.vue?vue&type=template&id=5472b70c&scoped=true"
import script from "./integral-search.vue?vue&type=script&lang=js"
export * from "./integral-search.vue?vue&type=script&lang=js"
import style0 from "./integral-search.vue?vue&type=style&index=0&id=5472b70c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5472b70c",
  null
  
)

export default component.exports